import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { getReadOnly } from '../../../selectors/permissions';
import AlertMessage, { LAYOUT_OPTIONS } from '../../utilities/AlertMessage';
import css from './PageWrapper.css';

const PageWrapper = React.forwardRef(
    (
        {
            style = {},
            containerWrapperClass = null,
            children = null,
            onMouseEnter = null,
            onMouseLeave = null,
            className = null,
            allowDropDownPageScrolling = false,
            disablePadding = false,
            dataTestId,
        },
        ref
    ) => {
        const readOnly = useSelector(getReadOnly);

        return (
            <div className={classNames(css.containerWrapper, containerWrapperClass)} data-testid={dataTestId}>
                <div
                    className={classNames(css.container, className, {
                        [css.containerWithPadding]: !disablePadding,
                        [css.containerWithDropDownScrolling]: allowDropDownPageScrolling,
                        [css.readOnlyBannerContainer]: readOnly,
                    })}
                    style={style}
                    ref={ref}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                >
                    {readOnly && (
                        <AlertMessage
                            level="info"
                            layout={LAYOUT_OPTIONS.EMBEDDED}
                            text="STATIC.GENERAL_MESSAGES.READ_ONLY_BANNER"
                            className={css.readOnlyBanner}
                        />
                    )}
                    {children}
                </div>
            </div>
        );
    }
);

PageWrapper.propTypes = {
    children: PropTypes.any, // eslint-disable-line
    style: PropTypes.objectOf(PropTypes.any),
    containerWrapperClass: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    className: PropTypes.string,
    allowDropDownPageScrolling: PropTypes.bool,
    disablePadding: PropTypes.bool,
    dataTestId: PropTypes.string,
};

export default PageWrapper;
